import React, { useReducer } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";
import axios from "axios"
import { CircularProgress } from '@material-ui/core';
import ConfirmationContent from "./ConfirmationContent"
import {decisionReducer} from "../../../../Utils/requestUtils"


function ConfirmationDialog(props) {
    let {bill_payment, observation, open, onClose, isApproved} = props
    const history = useHistory()

    const [dialogState, dispatchDialogState] = useReducer(
        decisionReducer,
        {isLoading: false, isError: false, finished:false}
    )

    const handleFinish = (analysis_status) =>{
        dispatchDialogState({type:"send_request_init"})
        let payload={
            analysis_status: analysis_status,
        }
        if (observation != null && observation !== ""){
            payload ={...payload, observation: observation}
        }
        setTimeout(function () {
            axios.put('/dash/bill_payment/bill_payment/' + bill_payment.bill_payment_key, payload).then(response => {
                dispatchDialogState({type:"send_request_success"})
              }).catch(error => { 
                if ((error.response || {}).status === 403) dispatchDialogState({type: "send_request_failure_403"})
                else if ((error.response || {}).status === 409) dispatchDialogState({type: "send_request_failure_409"})  
                else dispatchDialogState({type: "send_request_failure"})    
              });
        }, 1000);
    }

    if (dialogState.finished && dialogState.isLoading){
        return (
            <Dialog 
                open={open} 
                onClose={() => history.push("/bill-payments-inbox")} 
                keepMounted={false}
                disableBackdropClick
                disableEscapeKeyDown
            >
                <DialogTitle style={{paddingBottom: "0px"}} className={["blueText", "normalMediumSize"].join(" ")}>Finalizar Pagamento de Conta</DialogTitle>
                <DialogContent>
                    <div style={{display:"flex", width: "450px", height:"310px"}}>
                        <CircularProgress style={{margin:"auto"}} />
                    </div>
                </DialogContent>
            </Dialog>

        )
    }
    else if (dialogState.finished){
        let confirmationData = {    
            message: dialogState.message,
            success: !dialogState.isError
        }
        return (
            <Dialog 
                open={open} 
                onClose={() => history.push("/bill-payments-inbox")} 
                keepMounted={false}
                disableBackdropClick
            >
                <DialogTitle style={{paddingBottom: "0px"}} className={["blueText", "normalMediumSize"].join(" ")}>Confirmação de Revisão</DialogTitle>
                <DialogContent>
                    <div style={{display:"flex", flexDirection:"column", width: "450px", height:"310px"}}>
                        <ConfirmationContent onClose={() => history.push("/bill-payments-inbox")} data={confirmationData} />
                    </div>
                </DialogContent>
            </Dialog>
        )

    }
    return (
        <Dialog 
        open={open} 
        onClose={onClose} 
        keepMounted={false}
        >
            <DialogTitle style={{paddingBottom: "0px"}} className={["blueText", "normalMediumSize"].join(" ")}>Finalizar Pagamento de Conta</DialogTitle>
            <DialogContent>
                <div style={{display: "flex", flexDirection:"column", width: "450px", height:"310px"}}>
                    <TextField
                        style={{display:"flex",flexGrow:1,alignItems:"center"}}
                        fullWidth
                        multiline
                        variant="outlined"
                        margin="dense"
                        rows="10"
                        defaultValue={observation}
                        disabled={true}
                    />
                    <div className="internalCardContainer" style={{display:"flex", justifyContent:"center"}}>
                        {isApproved === true ?
                        <div 
                            className={["button", "approved", "normalText", "normalMediumSize"].join(" ")}
                            style={{padding:"5px 30px"}}
                            onClick={() => handleFinish("manually_approved")}
                        >
                            Aprovar
                        </div> :
                        isApproved === false ?
                        <div 
                            className={["button", "reproved", "normalText", "normalMediumSize"].join(" ")}
                            style={{padding:"5px 30px"}}
                            onClick={() => handleFinish("manually_reproved")}
                        >
                            Reprovar
                        </div> : null
                        }
                        <div 
                            className={["button", "cancel", "normalText", "normalMediumSize"].join(" ")}
                            style={{padding:"5px 30px"}}
                            onClick={onClose}
                        >
                            Cancelar 
                        </div>
                  </div>
              </div>
          </DialogContent>
        </Dialog>
    )
}

export default ConfirmationDialog;